import * as R from "ramda";
import { RootState } from "../../store";
import { nullOrValue } from "../../helper/utils";

export const selectLatestRecord = (state: RootState) =>
    nullOrValue(R.head(
        R.sort(
            (a, b) => b.date.getTime() - a.date.getTime(),
            state.history.records
        )
    ));